import React, { Component } from 'react';
import IconSet from './IconSet';
import icons56 from '../../assets/images/icons-menu_58.png';
import icons28 from '../../assets/images/icons-menu_28.png';
import icons40 from '../../assets/images/icons-menu_40.png';

class IconSetMenu extends Component {
  render() {
    const items = ['home', 'recruitment', 'recruit', 'company', 'sample', 'units', 'team', 'ethic', 'about', 'contact', 'chevron', 'login', 'previous', 'next'];
    const sets = { 'size_28': icons28, 'size_56': icons56, 'size_46': icons56, 'size_40': icons40  };
    return <IconSet items={items} size={56} sets={sets} iconButton={true} {...this.props} />

  }
}

export default IconSetMenu;



// WEBPACK FOOTER //
// ./src/components/Icon/IconSetMenu.jsx